import React, { useEffect, useState } from 'react';
import s from './index.module.less';

const RechargeRegularPopup = ({ open, onClose, onRecharge, compact = false }) => {
  const [mounted, setMounted] = useState(open);
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    if (open) {
      setMounted(true);
      const frame = window.requestAnimationFrame(() => setEntered(true));
      return () => window.cancelAnimationFrame(frame);
    }
    setEntered(false);
    setMounted(false);
  }, [open]);

  if (!mounted) return null;

  return (
    <div className={`${s.popup} ${compact ? s.compact : ''} ${entered ? s.visible : ''}`} role="dialog" aria-label="补充算力">
      {!compact && <button className={s.close} type="button" aria-label="关闭" onClick={onClose}>×</button>}
      {compact && <button className={s.compactClose} type="button" aria-label="关闭" onClick={onClose} />}
      <button className={s.recharge} type="button" onClick={onRecharge}>立即补充算力</button>
      <button className={s.later} type="button" onClick={onClose}>稍后再说</button>
    </div>
  );
};

export default RechargeRegularPopup;
